module.exports = __webpack_public_path__ + "img/not_found.9e2a331a.png";